<template>
  <div class="column is-12">
    <div class="card is-fullwidth panel-info">
      <header class="card-header">
        <p class="card-header-title panel-heading-info">{{ occurrence ? 'Charge' : 'Debit/Credit' }}</p>
      </header>
      <div class="card-content">
        <div class="content">
          <div class="control" v-if="!occurrence">
            <textarea :class="{'textarea': true, 'is-danger': errors.has('description') }" name="description" id="description" placeholder="" v-model="charge.description" v-validate data-vv-rules="required"></textarea>
            <span v-show="errors.has('description')" class="help is-danger">{{ errors.first('description') }}</span>
          </div>
          <div class="control is-grouped">
            <p class="control is-expanded" v-if="!type">
              <label class="label">Type</label>
              <select class="select is-fullwidth" v-model="charge.type" name="type" id="type" @change="setTotal()">
                <option value='1'>Credit</option>
                <option value='2' v-if="(!occurrence) || parseInt(charge.charge_option) !== 2">Debit</option>
              </select>
            </p>
            <p class="control" v-if="occurrence">
              <label class="label">Address to</label>
              <select style="margin-right: 10px;" class="select is-pulled-right" v-model="charge.address" @change="clearValues()">
                <option value="3">ALL</option>
                <option value="1">CUSTOMER</option>
                <option value="2">SUPPLIER</option>
                <option v-if="parseInt(charge.charge_option) === 1" value="4">DIRECT</option>
              </select>
            </p>
            <p class="control" v-if="occurrence" @change="setType()">
              <label class="label">Charge Option</label>
              <select style="margin-right: 10px;" class="select" v-model="charge.charge_option" ref="charge_option">
                <option value="1">PARTIAL</option>
                <option value="2">FREE CHARGES</option>
              </select>
            </p>
            <template v-if="!occurrence">
              <p class="control">
                <label class="label">Price</label>
                <input :class="{'input': true, 'is-danger': errors.has('price')}" name="price" id="price" type="text" placeholder="" v-model="charge.price" v-validate="`required|decimal|min_value:0.01|max_value:20`">
                <span v-show="errors.has('price')" class="help is-danger">{{ errors.first('price') }}</span>
              </p>
            </template>
            <a style="margin-top: 25px;" :class="{'button': true, 'is-primary': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="addCharge">Save Charge</a>
          </div>
          <div class="control is-grouped" v-if="occurrence">
            <p class="control" v-if="parseInt(charge.charge_option) === 1 && parseInt(charge.address) !== 1">
              <label class="label">Provider Price</label>
              <input :class="{'input': true, 'is-danger': errors.has('price')}" name="price" id="price" type="text" placeholder="" v-model="charge.price" v-validate="`required|decimal|min_value:0`" @change="setTotal()">
              <span v-show="errors.has('price')" class="help is-danger">{{ errors.first('price') }}</span>
            </p>
            <p class="control" v-if="parseInt(charge.charge_option) === 1 && (parseInt(charge.address) === 3)">
              <label class="label">Fee Price</label>
              <input :class="{'input': true, 'is-danger': errors.has('fee_price')}" name="fee_price" id="fee_price" type="text" placeholder="" v-model="charge.fee_price" v-validate="`required|decimal|min_value:0`" @change="setTotal()">
              <span v-show="errors.has('fee_price')" class="help is-danger">{{ errors.first('fee_price') }}</span>
            </p>
            <p class="control" v-if="parseInt(charge.charge_option) === 1 && parseInt(charge.address) === 3">
              <label class="label">Client Price</label>
              <input class="input" name="total" id="total" type="text" placeholder="" v-model="total" disabled>
            </p>
            <p class="control" v-if="parseInt(charge.charge_option) === 1 && parseInt(charge.address) === 1">
              <label class="label">Client Price</label>
              <input class="input" name="total" id="total" type="text" placeholder="" v-model="charge.price" v-validate="`required|decimal|min_value:0`">
            </p>
            <p class="control" v-if="parseInt(charge.charge_option) === 1 && parseInt(charge.address) === 4">
              <label class="label">Currency</label>
              <select style="margin-right: 10px;" class="select" v-model="currencyOptions" ref="currencyOptions">
                <option value="BRL">BRL</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="AUD">AUD</option>
                <option value="CAD">CAD</option>
                <option value="MXN">MXN</option>
                <option value="GBP">GBP</option>
                <option value="ARS">ARS</option>
                <option value="ZAR">ZAR</option>
                <option value="THB">THB</option>
              </select>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import message from '../../../utils/message'
  export default {
    props: {
      context: {
        type: Object
      },
      occurrence: {
        type: Object,
        defatult: null
      },
      type: {
        type: Number,
        default: null
      },
      invoice: {
        type: Object,
        defatult: null
      },
      payment: {
        type: Object,
        defatult: null
      }
    },
    data () {
      return {
        charge: {
          service_id: null,
          invoice_id: null,
          payment_id: null,
          occurrence_id: null,
          price: 0,
          fee_price: 0,
          address: 3,
          type: 2,
          description: '',
          charge_option: 1,
          currency: null
        },
        total: 0,
        inProgress: false,
        reload: false,
        currencyOptions: ''
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    },
    methods: {
      setType () {
        if (parseInt(this.charge.charge_option) === 2) {
          this.charge.type = 1
        } else {
          this.charge.type = 2
        }
      },
      setTotal () {
        if (this.occurrence) {
          let providerPrice = parseFloat(this.charge.price)
          let fee = 0
          if (parseInt(this.charge.type) === 1) {
            fee = -this.charge.fee_price
          } else {
            fee = this.charge.fee_price
          }
          if (this.occurrence.service.currency === this.occurrence.service.room.provider_currency) {
            if (this.occurrence.service.markup > 0) {
              // console.log('entrou1')
              if (parseInt(this.charge.type) === 1) {
                this.total = -((providerPrice / ((100 - parseFloat(this.occurrence.service.markup)) / 100)) + parseFloat(fee)).toFixed(2)
              } else {
                this.total = +((providerPrice / ((100 - parseFloat(this.occurrence.service.markup)) / 100)) + parseFloat(fee)).toFixed(2)
              }
            } else {
              // console.log('entrou2')
              let markupIndex = (parseFloat(this.occurrence.service.price) / parseFloat(this.occurrence.service.room.provider_price))
              let clientPrice = providerPrice * parseFloat(markupIndex)
              if (parseInt(this.charge.type) === 1) {
                this.total = -(parseFloat(clientPrice) + parseFloat(fee)).toFixed(2)
              } else {
                this.total = +(parseFloat(clientPrice) + parseFloat(fee)).toFixed(2)
              }
            }
          } else {
            if (this.occurrence.service.markup > 0) {
              // console.log('entrou3')
              let clientPrice = ((providerPrice / ((100 - parseFloat(this.occurrence.service.markup)) / 100)) * parseFloat(this.occurrence.service.exchange_provider))
              if (parseInt(this.charge.type) === 1) {
                this.total = -(parseFloat(clientPrice) + parseFloat(fee)).toFixed(2)
              } else {
                this.total = +(parseFloat(clientPrice) + parseFloat(fee)).toFixed(2)
              }
            } else {
              // console.log('entrou4')
              let markupIndex = parseFloat(this.occurrence.service.price) / (parseFloat(this.occurrence.service.room.provider_price) * parseFloat(this.occurrence.service.exchange_provider))
              let clientPrice = (parseFloat(providerPrice) * (parseFloat(this.occurrence.service.exchange_provider) * parseFloat(markupIndex)))
              if (parseInt(this.charge.type) === 1) {
                this.total = -(parseFloat(clientPrice) + parseFloat(fee)).toFixed(2)
              } else {
                this.total = +(parseFloat(clientPrice) + parseFloat(fee)).toFixed(2)
              }
            }
          }
        }
      },
      addCharge () {
        if (window.confirm('Are you sure you want to add charge?')) {
          this.inProgress = true
          setTimeout(() => {
            this.$validator.validateAll().then(() => {
              if (window.confirm('Are you really sure you want to add this charge?')) {
                // console.log(this.errors.items.length)
                if (this.errors.items.length === 0) {
                  this.charge.address = parseInt(this.charge.address)
                  this.charge.charge_option = parseInt(this.charge.charge_option)
                  // this.charge.occurrence_id = this.occurrence.id
                  if (this.occurrence) {
                    this.charge.service_id = this.occurrence.service_id
                    this.charge.occurrence_id = this.occurrence.id
                    if (this.type) {
                      this.charge.type = this.type
                    }
                    this.charge.description = this.occurrence.subject
                  }
                  this.charge.type = parseInt(this.charge.type)
                  if (this.invoice) {
                    this.charge.invoice_id = this.invoice.id
                  }

                  if (this.payment) {
                    this.charge.payment_id = this.payment.id
                  }

                  if (this.currencyOptions) {
                    this.charge.currency = this.currencyOptions
                  }

                  this.charge.type = parseInt(this.charge.type)
                  this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/charge', this.charge).then((response) => {
                    if (response.body.hasOwnProperty('error')) {
                      this.error = response.body.description
                    } else if (response.body === 'dispute') {
                      this.message('warning', 'Atenção', 'A reserva está em DISPUTA! Entre em contato com o Departamento Financeiro.', 60000)
                    } else {
                      if (this.occurrence) {
                        window.location.reload()
                      } else if (this.invoice) {
                        this.$root.$emit('reloadinvoice', true)
                      } else if (this.payment) {
                        this.$root.$emit('reloadpayment', true)
                      }
                      this.inProgress = false
                      this.clear()
                      this.error = ''
                    }
                  })
                }
              }
            })
            this.inProgress = false
          }, 4000)
        }
      },
      clear () {
        this.charge.price = 0
        this.charge.fee_price = 0
        if ((this.invoice) || (this.payment)) {
          this.charge.description = ''
        }
        this.$validator.reset()
      },
      clearValues () {
        this.charge.price = 0
        this.charge.fee_price = 0
        this.total = 0
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-success {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
    color: #23d160;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-success {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
    background-color: rgb(35, 209, 96);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-heading-card {
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-info {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #3273dc;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-info {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
    background-color: rgb(50, 115, 220);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-warning {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
    color: #ffdd57;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-warning {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
    background-color: rgb(255, 221, 87);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Charge.vue?45a98a7b